import { render, staticRenderFns } from "./TalentMatrixView.vue?vue&type=template&id=84d1d472&scoped=true"
import script from "./TalentMatrixView.vue?vue&type=script&lang=js"
export * from "./TalentMatrixView.vue?vue&type=script&lang=js"
import style0 from "./TalentMatrixView.vue?vue&type=style&index=0&id=84d1d472&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "84d1d472",
  null
  
)

export default component.exports